var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"status-message-container"},[_c('div',{staticClass:"status-message button is-info",on:{"click":_vm.statusMessageClear}},[_vm._v(" "+_vm._s(_vm.$store.getters.statusMessage)+" ")])])}
var staticRenderFns = []

export { render, staticRenderFns }